module.exports = __webpack_public_path__ + "static/media/four-squares-icon.c03339dc.svg";